import dotsIcon from 'Assets/images/three-dots-vertical.svg';
import cx from 'classnames';
import ActivityItemPresenceDisplayObserver from 'Components/ActivityItemPresenceDisplay';
import { ChatListItemTextRenderer } from 'Components/ChatList/ChatListItemText/ChatListItemTextRenderer';
import LazyLoader from 'Components/LazyLoader';
import { PopOverMenu } from 'Components/shared/PopOverMenu';
import {
  STORE_CONFIG,
  STORE_PARTICIPANT,
  STORE_PHONE_CALL,
  STORE_UI,
} from 'Constants/stores';
import withRouter from 'Hocs/WithRouter';
import { AxiosResponseT, ResultsCollection } from 'Interfaces/axiosResponse';
import { get, isEmpty } from 'lodash';
import { action, observable, makeObservable } from 'mobx';
import { inject, observer } from 'mobx-react';
import { IPromiseBasedObservable } from 'mobx-utils';
import { ContactModelV2 } from 'Models/ContactModelV2';
import { ParticipantModel } from 'Models/ParticipantModel';
import { useUIStore } from 'Modules/ui/index.store';
import * as React from 'react';
import { NavLink } from 'react-router';
import { Button, List, Message, Modal } from 'semantic-ui-react';
import { isNullOrUndefined } from 'util';
import { getCurrentConversationId } from 'Utils/getCurrentConversationId';
import { selectProperVideoTooltipMessageForGroups } from 'Utils/videoConferenceUtils';
import { ActivityItemPhoneVideoButtons } from '../../components/ActivityItemPhoneVideoButtons';

import { formatNumberNoPlusIfUS } from '../../utils/phoneUtil';
import { ChatDetailsButton } from '../ActivityItemPhoneVideoButtons/ChatDetailsButton';
import MoreActivityButton from '../MoreActivityButtons';
import { IconButton } from '../shared/IconButton';
import { Styled } from './index.styles';
import { ActivityListItemProps } from './interface';

/**
 * **This named class is not decorated with `@observer`.** Use the default export from this module if you need the decorated class.
 * @export
 * @class ActivityListItem
 */
const testid = 'activityListitem';

export class ActivityListItem extends React.Component<
  ActivityListItemProps,
  { showConfirmationModal: boolean }
> {
  button;
  constructor(props: ActivityListItemProps) {
    super(props);
    makeObservable(this);
    this.setConversationTopic(props.conversation?.topic);
    this.state = {
      showConfirmationModal: false,
    };
    this.button = React.createRef();
  }

  @observable
  hovered = false;

  @action
  setHovered = (hovered: boolean) => (this.hovered = hovered);

  @observable
  clickedMoreOptionsId = '';

  @action
  setClickedMoreOptionsId = (clickedId: string) =>
    (this.clickedMoreOptionsId = clickedId);

  componentDidUpdate() {
    if (this.button.current) {
      this.button.current.focus();
    }
  }

  detailsClick = (e) => {
    const {
      conversation,
      participantsPbo,
      loggedInPersonId,
      personStore,
      conversationStore,
      ui,
      from,
      handleDetails,
      currentPersonId,
      isPerson,
    } = this.props;
    e.preventDefault();

    if (from === 'group-info') {
      handleDetails(
        currentPersonId,
        isPerson ? 'person' : 'contact',
        'personInfo'
      );

      return;
    } else {
      if (
        conversation &&
        (conversation?.grouping === 'Channel' ||
          conversation?.grouping === 'Group')
      ) {
        conversationStore.setChannelInfoDetails(conversation?.id, 'group-info');
        useUIStore
          .getState()
          .setEntitySidePanelInfo({ groupConversationId: conversation?.id });
      } else if (conversation && conversation?.grouping === 'OneOnOne') {
        if (participantsPbo !== null) {
          void participantsPbo.then((ptcResp) => {
            const ptcDataResults: ParticipantModel[] = get(
              ptcResp,
              'data.results',
              []
            );
            const otherConversationParticipants = ptcDataResults.filter(
              (p) => get(p, 'personId', 0) !== loggedInPersonId
            );
            const mySelf = ptcDataResults.find(
              (p) => get(p, 'personId', 0) === loggedInPersonId
            );
            if (
              !isNullOrUndefined(otherConversationParticipants) &&
              otherConversationParticipants.length === 1
            ) {
              const otherPersonId = get(
                otherConversationParticipants[0],
                'personId',
                0
              );
              if (otherPersonId !== 0) {
                useUIStore.getState().setEntitySidePanelInfo({
                  entityId: otherPersonId.toString(),
                  entityType: 'person',
                });
                conversationStore.setChannelInfoDetails(
                  conversation?.id,
                  'new'
                );
              } else {
                const otherPersonPhone = get(
                  otherConversationParticipants[0],
                  'phone',
                  null
                );
                const extrContact =
                  otherPersonPhone &&
                  personStore.getExtrContactByPhoneNumber(otherPersonPhone);

                if (extrContact) {
                  useUIStore.getState().setEntitySidePanelInfo({
                    entityId: otherPersonPhone,
                    entityType: 'extrContact',
                  });
                  conversationStore.setChannelInfoDetails('0', 'new');
                } else {
                  useUIStore.getState().setEntitySidePanelInfo({
                    entityId: otherPersonPhone,
                    entityType: 'unknownContact',
                  });
                  conversationStore.setChannelInfoDetails('0', 'new');
                }
              }
            } else {
              const mySelfPersonId = get(mySelf, 'personId', 0);
              useUIStore.getState().setEntitySidePanelInfo({
                entityId: mySelfPersonId.toString(),
                entityType: 'person',
              });
              conversationStore.setChannelInfoDetails('0', 'new');
            }
          });
        } else {
          throw new Error(
            'Failed to retrieve Participants for Conversation ' +
              conversation?.id
          );
        }
      }
    }
  };

  toggleMuteStatus = (conversationid: string): boolean => {
    const { ui } = this.props;
    const value = ui.selectIfConvMuted(conversationid);
    ui.setConvMuted(conversationid, !value);
    ui.setMoreActionOptions({ show: false, conversationId: '' });
    return !value;
  };

  placeVideoCallConference = () => {
    const { postConferenceByConversationId, conversation, currentPersonId } =
      this.props;
    if (!currentPersonId) {
      postConferenceByConversationId(conversation?.id);
      return;
    }

    this.props.conversationStore
      .loadOrCreateConversationWithPost(currentPersonId)
      .then((resp) => {
        postConferenceByConversationId(resp.data.id?.toString());
      });
  };

  @action
  onMouseOver = () => this.setHovered(true);

  @action
  onMouseLeave = () => this.setHovered(false);

  @observable
  conversationTopic: string;

  @action
  setConversationTopic = (conversationTopic: string) =>
    (this.conversationTopic = conversationTopic);

  handleArchiveConversation = (conversationId: string) => () => {
    const { ui } = this.props;
    this.props.conversationStore
      .removeFromRecentHistList(conversationId)
      .then(() => {
        ui.setMoreActionOptions({ show: false, conversationId: '' });
      });
  };

  openMoreOptions = (conversationId: string) => (e) => {
    const { ui } = this.props;
    e.preventDefault();
    e.stopPropagation();
    ui.setMoreActionOptions({ conversationId: conversationId, show: true });
  };

  toggleConfirmationModal = (e) => {
    const { ui } = this.props;
    e.stopPropagation();
    ui.setMoreActionOptions({ show: false, conversationId: '' });
    this.setState({ showConfirmationModal: !this.state.showConfirmationModal });
  };

  clearScrollToMessageId = (e) => {
    if (useUIStore.getState().entitySidePanelInfo) {
      useUIStore.getState().resetEntitySidePanel();
      this.detailsClick(e);
    }
    this.props.ui.setMessageIdToScroll('');
    const { conversation, navigate, linkSuffix, ui, conversationStore } =
      this.props;
    conversationStore.setPreviousConversation(getCurrentConversationId());
    navigate(
      conversation?.id
        ? `/chat/conversations/${conversation.id}/${linkSuffix || 'chat'}`
        : '/chat'
    );

    ui.setMessageIdToScroll('');
  };

  render() {
    const buttonSize = 'small';

    const {
      config,
      conversation,
      conversationId,
      linkSuffix,
      loggedInPersonId,
      loggedInUserActiveConferenceConversation,
      participantsPbo,
      selectParticipantPersonInfo,
      ui,
      from,
      currentPersonId,
      personStore: { personAvaliableFeatures },
    } = this.props;

    let personPbo: IPromiseBasedObservable<ContactModelV2> = null;
    let rootParticipant: ParticipantModel = null;
    const isOneOnOne =
      from === 'group-info' ? true : conversation?.grouping === 'OneOnOne';
    const grouping =
      from === 'group-info' ? 'OneOnOne' : conversation?.grouping;
    const conferenceIsActive =
      !isNullOrUndefined(conversation?.activeConference) &&
      conversation?.activeConference.sessionId !== '';
    const userIsInActiveVideoConference = !isNullOrUndefined(
      loggedInUserActiveConferenceConversation
    );

    const isCurrentConversation =
      getCurrentConversationId() === conversation?.id;

    const isVideoCallDisabled =
      !!loggedInUserActiveConferenceConversation ||
      !personAvaliableFeatures.video.enabled;

    return (
      <List.Item
        as={NavLink}
        to={
          conversation?.id
            ? `/chat/conversations/${conversation?.id}/${linkSuffix || 'chat'}`
            : '/chat'
        }
        className={cx('list-item-ih semantic-flex-row showhover', {
          active: isCurrentConversation,
          hovered: this.hovered || from === 'group-info',
        })}
        onMouseOver={this.onMouseOver}
        onMouseLeave={this.onMouseLeave}
        id={conversation?.id}
        key={conversationId}
        onClick={this.clearScrollToMessageId}
      >
        <List.Content className="list-item-ih-image semantic-flex-zero">
          {/* IMPORTANT: Checks against `participantsPbo` must be against `null` (see ParticipantStore.selectConversatinParticipants) RP 2018-12-12 */}
          {participantsPbo !== null &&
            participantsPbo.case({
              pending: () => <LazyLoader size="tiny" />,
              rejected: (reason) =>
                reason.message === 'Network Error' ? null : (
                  <Message
                    visible
                    error
                    content={
                      'Error loading Participant: ' +
                      get(reason, 'response.data.message', 'No Message')
                    }
                  />
                ),
              fulfilled: (
                ptcResp: AxiosResponseT<ResultsCollection<ParticipantModel>>
              ) => {
                const ptcDataResults: ParticipantModel[] = get(
                  ptcResp,
                  'data.results',
                  []
                );
                const otherPerson = ptcDataResults.find(
                  (p) =>
                    get(p, 'personId', 0) > 0 &&
                    get(p, 'personId', 0) !== loggedInPersonId
                );
                const otherPersonPhoneNumber = ptcDataResults.find(
                  (p) => !isNullOrUndefined(p.phone)
                );
                const mySelf = ptcDataResults.find(
                  (p) => get(p, 'personId', 0) === loggedInPersonId
                );
                const phoneNumNoPlus = isEmpty(otherPersonPhoneNumber?.phone)
                  ? null
                  : formatNumberNoPlusIfUS(otherPersonPhoneNumber.phone);

                if (
                  !isNullOrUndefined(otherPerson) &&
                  isNullOrUndefined(otherPersonPhoneNumber)
                ) {
                  const opId = get(otherPerson, 'personId', 0);

                  personPbo = selectParticipantPersonInfo(opId.toString());
                  return (
                    <ActivityItemPresenceDisplayObserver
                      conversationGrouping={grouping}
                      conversationId={conversation?.id}
                      personId={opId.toString()}
                      phoneNumber={phoneNumNoPlus}
                      personPbo={personPbo}
                      showUnread={true}
                    />
                  );
                } else if (
                  mySelf !== undefined &&
                  otherPerson === undefined &&
                  isNullOrUndefined(otherPersonPhoneNumber)
                ) {
                  // nobody but yourself (so lonely)
                  personPbo = selectParticipantPersonInfo(
                    mySelf.personId.toString()
                  );
                  return (
                    <ActivityItemPresenceDisplayObserver
                      conversationGrouping={grouping}
                      conversationId={conversation?.id}
                      personId={loggedInPersonId.toString()}
                      personPbo={personPbo}
                      phoneNumber={phoneNumNoPlus}
                      showUnread={true}
                    />
                  );
                } else {
                  // external/unknown users
                  return (
                    <ActivityItemPresenceDisplayObserver
                      conversationGrouping={grouping}
                      conversationId={conversation?.id}
                      phoneNumber={phoneNumNoPlus}
                      personId={get(otherPerson, 'personId', 0)?.toString()}
                      personPbo={personPbo}
                      showUnread={true}
                    />
                  );
                }
              },
            })}
        </List.Content>
        <List.Content className="list-item-ih-content semantic-flex-fluid">
          {participantsPbo?.case({
            pending: () => <LazyLoader size="tiny" />,
            rejected: (reason) =>
              reason.message === 'Network Error' ? null : (
                <Message
                  visible
                  error
                  content={
                    'Error loading Participant: ' +
                    get(reason, 'response.data.message', 'No Message')
                  }
                />
              ),
            fulfilled: () => {
              return (
                <ChatListItemTextRenderer
                  conversation={conversation}
                  from={from}
                />
              );
            },
          })}
        </List.Content>

        {!this.hovered &&
          ui.selectIfConvMuted(conversationId) &&
          ['recentFevList', 'history'].includes(from) && <Styled.MutedIcon />}

        <List.Content
          className={cx('list-item-ih-hover-buttons semantic-flex-shrink', {
            active: isCurrentConversation,
            hovered: this.hovered || from === 'group-info',
          })}
        >
          {isOneOnOne && participantsPbo !== null && (
            <ChatDetailsButton
              compact
              onClick={this.detailsClick}
              {...{
                size: buttonSize,
                popupPosition: 'bottom right',
                testid,
              }}
            />
          )}
          {isOneOnOne &&
            participantsPbo !== null &&
            participantsPbo.case({
              pending: () => <LazyLoader size="tiny" />,
              rejected: (reason) =>
                reason.message === 'Network Error' ? null : (
                  <Message
                    visible
                    error
                    content={
                      'Error loading Participant: ' +
                      get(reason, 'response.data.message', 'No Message')
                    }
                  />
                ),
              fulfilled: (
                ptcResp: AxiosResponseT<ResultsCollection<ParticipantModel>>
              ) => {
                const ptcDataResults: ParticipantModel[] = get(
                  ptcResp,
                  'data.results',
                  []
                );
                const otherPtcs = ptcDataResults.filter(
                  (p) => get(p, 'personId', 0) !== loggedInPersonId
                );
                if (otherPtcs.length > 0) {
                  rootParticipant = otherPtcs.find(
                    (p) =>
                      p.personId?.toString() === currentPersonId?.toString()
                  );
                  if (
                    rootParticipant !== undefined &&
                    rootParticipant !== null
                  ) {
                    if (get(rootParticipant, 'personId', 0) !== 0) {
                      personPbo = selectParticipantPersonInfo(
                        rootParticipant.personId.toString()
                      );
                      if (personPbo !== undefined) {
                        return (
                          <ActivityItemPhoneVideoButtons
                            conversation={conversation}
                            compact
                            buttonSize={buttonSize}
                            grouping={grouping}
                            personPbo={personPbo}
                            currentPersonId={currentPersonId?.toString()}
                            from={from}
                          />
                        );
                      }
                    } else {
                      return (
                        <ActivityItemPhoneVideoButtons
                          conversation={conversation}
                          buttonSize={buttonSize}
                          grouping={grouping}
                          from={from}
                          phone={rootParticipant.phone}
                          currentPersonId={currentPersonId?.toString()}
                        />
                      );
                    }
                  }
                }
                return <span />;
              },
            })}
          {!isOneOnOne && (
            <>
              <ChatDetailsButton
                compact
                isGroupChat
                onClick={this.detailsClick}
                {...{
                  size: buttonSize,
                  popupPosition: 'bottom right',
                  testid,
                }}
              />
              {config &&
                !isVideoCallDisabled &&
                !conversation?.IsSmsConversation && (
                  <IconButton
                    compact
                    onClick={this.placeVideoCallConference}
                    content={selectProperVideoTooltipMessageForGroups(
                      conferenceIsActive,
                      userIsInActiveVideoConference
                    )}
                    disabled={{
                      title: 'Video conference unavailable',
                      condition:
                        userIsInActiveVideoConference ||
                        !personAvaliableFeatures.video.enabled,
                    }}
                    icon="video"
                    testid={`${testid}-buttonStartVideoCall`}
                    {...{ popupPosition: 'bottom right', size: buttonSize }}
                  />
                )}
            </>
          )}
          {from !== 'group-info' && (
            <>
              <PopOverMenu
                key="activity-list-item"
                position="right center"
                trigger={
                  <Button
                    basic
                    compact
                    onClick={this.openMoreOptions(conversationId)}
                    className="zero-right-pm"
                  >
                    <img className="small-icon" src={dotsIcon} />
                  </Button>
                }
                content={
                  ui.showMoreActionOptions.conversationId ===
                    conversationId && (
                    <MoreActivityButton
                      currentPersonId={currentPersonId?.toString()}
                      toggleMuteStatus={this.toggleMuteStatus}
                      showMoreActionOptions={
                        ui.showMoreActionOptions.conversationId ===
                        conversationId
                      }
                      conversation={conversation}
                      personPbo={personPbo}
                      toggleConfirmationModal={this.toggleConfirmationModal}
                      from={from}
                    />
                  )
                }
                onOutsideClick={() => {
                  ui.setMoreActionOptions({ show: false, conversationId: '' });
                }}
                show={
                  ui.showMoreActionOptions.conversationId === conversationId
                }
              />
              <Modal
                size="mini"
                id="confirmation-modal"
                open={this.state.showConfirmationModal}
                dimmer="blurring"
                closeOnDimmerClick={true}
                centered={true}
                onClose={this.toggleConfirmationModal}
                className="confirmation-modal"
              >
                <Modal.Content>
                  <div className="text-center margin-top-1rem">
                    {/* TODO: This copy is related to v1 */}
                    Chat will be removed from your <b>
                      {'Recent History'}
                    </b>{' '}
                    list. Are you sure you want to continue?
                  </div>
                  <div className="buttons semantic-flex-row semantic-flex-align-items-center semantic-flex-justify-space-around margin-top-2rem">
                    <Button
                      primary
                      onClick={this.handleArchiveConversation(conversationId)}
                      type="submit"
                      ref={this.button}
                    >
                      Confirm
                    </Button>
                    <Button secondary onClick={this.toggleConfirmationModal}>
                      Cancel
                    </Button>
                  </div>
                </Modal.Content>
              </Modal>
            </>
          )}
        </List.Content>
      </List.Item>
    );
  }
}
export default inject(
  STORE_CONFIG,
  STORE_PHONE_CALL,
  STORE_UI,
  STORE_PARTICIPANT
)(withRouter(observer(ActivityListItem)));
